<div *ngIf="loading; else loaded">
  <h3 class="panel-title"><i class="fa-solid fa-spinner fa-spin"></i> Loading...</h3>
</div>
<ng-template #loaded>
  <ng-container *ngIf="launching">
    <div class="flex-center-row light-content-panel">
      <h3 class="panel-title">
        <i class="fa-solid fa-spinner fa-spin"></i> Just a second, we are launching your recovery.
      </h3>
    </div>
  </ng-container>
  <ng-container *ngIf="!launching">
    <div class="flex-left-column light-control-host">
      <div class="flex-center-row">
        <h3 class="panel-title">Launch recovery for "{{ !!application ? application.name : '' }}"</h3>
      </div>
      <div class="margin-top">
        Select applications to recover to
        {{ !!application ? application.targetRegion : '' }}
      </div>
      <!-- Select All Checkbox -->
      <div class="select-all-container resource-type flex-center-row margin-top" *ngIf="applications.length > 0">
        <input
          type="checkbox"
          class="arpio-checkbox"
          [checked]="areAllApplicationsSelected()"
          (change)="toggleSelectAllApplications($event.target.checked)"
          [disabled]="applications.length === 0"
        />
        <div class="select-all-label" (click)="toggleSelectAllApplications(!areAllApplicationsSelected())">
          {{ areAllApplicationsSelected() ? 'Deselect All' : 'Select All' }}
        </div>
      </div>
      <div class="flex-center-row full-width margin-top">
        <div id="applicationSelectionList" class="light-content-panel spacer">
          <div class="flex-center-row" *ngFor="let application of applications; trackBy: applicationTrackBy">
            <ng-container *ngLet="computeApplicationRecoveryPoint(application.applicationObj) as appRp">
              <input
                id="app-id"
                class="arpio-checkbox"
                type="checkbox"
                (input)="toggleApplicationSelection(application.applicationObj.applicationId)"
                [checked]="applicationIsChecked(application.applicationObj)"
              />
              <div class="application-name margin-left">
                {{ application.applicationObj.name }}
              </div>
              <div class="spacer"></div>
              <ng-container *ngIf="application.selected">
                <div class="flex-center-row" *ngIf="appRp; else noMatchingRpBlock">
                  <ng-container *ngIf="showLock(appRp)">
                    <i class="fa-utility fa-semibold fa-lock"></i>
                  </ng-container>
                  <div class="recovery-timestamp-text half-margin-left">
                    {{ recoversToTimeString(application.applicationObj, appRp) }}
                  </div>
                </div>
                <ng-template #noMatchingRpBlock
                  ><div class="recovery-timestamp-error">No matching recovery points</div></ng-template
                >
              </ng-container>
            </ng-container>
          </div>
        </div>
      </div>

      <ng-container *ngIf="showRetainedRpsCheckbox">
        <div class="flex-center-row margin-top">
          <input
            id="only-protected-rps"
            class="arpio-checkbox"
            type="checkbox"
            (input)="computeApplicationsRecoveryPoint()"
            [(ngModel)]="onlyProtectedRps"
          />
          <label for="only-protected-rps">
            <div class="flex-center-row">
              <h4 class="half-margin-left">Restrict to indefinitely-retained Recovery Points</h4>
              <i class="fa-utility fa-semibold fa-lock half-margin-left"></i>
            </div>
          </label>
        </div>
      </ng-container>

      <ng-container *ngIf="canAdjustRecoveryPoint; else cantAdjustRecoveryPoint">
        <div class="double-margin-top flex-center-row full-width">
          <h4 class="spacer">Recovery Point</h4>
          <h4 class="">{{ recoveryPointTime }}</h4>
        </div>
        <rp-range-slider
          class="full-width"
          [recoveryPoints]="recoveryPoints"
          [enableRealTimeRecovery]="enableRealTimeRecovery"
          (update)="recoveryPointChanged($event)"
        >
        </rp-range-slider>
      </ng-container>
      <recovery-time-info
        [realTime]="selectedIsRealTime"
        [snapshotTime]="recoveryPointSnapshotTime"
      ></recovery-time-info>

      <ng-container *ngIf="accountService.quarantineEnabled && !isAzure">
        <div class="flex-center-row margin-top">
          <input
            id="quarantine-recovery-enabled"
            class="arpio-checkbox slight-margin-top"
            type="checkbox"
            (input)="toggleQuarantineRecovery($event)"
            [checked]="quarantineRecoveryEnabled"
          />
          <h4 class="half-margin-left">Enable Quarantine Mode for Ransomware Recovery</h4>
        </div>
        <div class="margin-top">
          With Quarantine Mode enabled, EC2 instances recover into an isolated state. You can release them individually
          from quarantine in the recovery environment.
          <a href="{{ uiService.ransomwareDocsUrl }}" target="_blank">Learn more.</a>
        </div>
        <ng-container *ngIf="accountService.entitledForCapability('malwareScan')">
          <div class="flex-child-indent margin-top">
            <input
              class="arpio-checkbox slight-margin-top"
              type="checkbox"
              id="run-scan"
              (input)="toggleMalwareScan($event)"
              [checked]="malwareScanEnabled"
              [disabled]="!quarantineRecoveryEnabled"
            />
            <label for="run-scan" class="half-margin-left">Run GuardDuty Malware Scan on Quarantined Instances</label>
          </div>
        </ng-container>
      </ng-container>
      <ng-template #cantAdjustRecoveryPoint>
        <div class="double-margin-top flex-center-row full-width">
          <h4 class="spacer">Recovery Point Locked At {{ recoveryPointTime }}</h4>
        </div>
      </ng-template>
      <div class="flex-center-row double-margin-top full-width">
        <div class="spacer"></div>
        <button class="arpio-secondary-button" (click)="onCancelClick()">CANCEL</button>
        <button
          busy-button
          [busy]="launching"
          id="failover-button"
          class="arpio-button margin-left"
          (click)="onLaunchClick()"
          [disabled]="launching"
        >
          LAUNCH RECOVERY
        </button>
        <div class="spacer"></div>
      </div>
    </div>
  </ng-container>
</ng-template>
